import {ITextConfig, ICloneable} from '../../Interfaces';
import {Label} from './Label';
import {Selectable} from '../Selectable';
import { TextArrow } from "./TextArrow";
import { ArrowHolder } from './ArrowHolder';
import { Line } from '../Line';


declare let THREE: any;

export class Text extends Selectable implements ICloneable {

  public config: ITextConfig;
  private image: HTMLImageElement;

  public scale;
  public scaleCor;
  constructor() {
    super();
    this.add(new Label());
    
    this.add(new TextArrow(new THREE.Vector3(0, 0, 0)));
    this.scaleCor = 1;
  }

  update(image: HTMLImageElement) {
    if (image) {
    this.image = image;
    this.getObjectByName<Label>(Label.Name).update(image);
    this.getObjectByName<ArrowHolder>(ArrowHolder.Name).visible = this.config.needArrow;
    this.getObjectByName<Line>(Line.Name).visible = this.config.needArrow;
    const startPos = new THREE.Vector3(this.getObjectByName<Label>(Label.Name).imageWidth / 12, 
    0, 
    this.getObjectByName<Label>(Label.Name).imageHeight / 12);
    this.getObjectByName<Line>(Line.Name).position.set(startPos.x, startPos.y, startPos.z);
    this.getObjectByName<TextArrow>(TextArrow.Name).update(startPos, this.getObjectByName<ArrowHolder>(ArrowHolder.Name).Position);
    this.scale.set(this.scaleCor, 1, this.scaleCor);
    this.selection.update();
    } else {
      this.scale.set(this.scaleCor, 1, this.scaleCor);
    }
  }

  // updateScale(scale) {
  //   const startPos = new THREE.Vector3(this.getObjectByName<Label>(Label.Name).imageWidth / 12 *  scale, 
  //   0, 
  //   this.getObjectByName<Label>(Label.Name).imageHeight / 12 * scale);
  //   // this.getObjectByName<Line>(Line.Name).position.set(startPos.x, startPos.y, startPos.z);
  //   // this.getObjectByName<TextArrow>(TextArrow.Name).update(startPos, this.getObjectByName<ArrowHolder>(ArrowHolder.Name).Position);
  // }

  getBoundingBoxObjects(): Array<any> {
    const bbObjs = [this.getObjectByName(TextArrow.Name)];
    bbObjs.push(this.getObjectByName(Label.Name));
    return this.getObjectByName(ArrowHolder.Name).visible ? bbObjs : [this.getObjectByName(Label.Name)];
  }

  duplicate(): Text {
    const txt = new Text();
    txt.config = {...this.config};
    txt.update(this.image);
    return txt;
  }

  getInfo() {
    let arrow = this.children.filter(ch => ch instanceof TextArrow)[0];
    let pos = {
      x: this.position.x,
      y: this.position.y,
      z: this.position.z
    };
    return {
      type: "Text",
      position: pos,
      imageSrc: this.image.src,
      config: this.config,
      startPoint: { x: arrow.startPoint.x, y: arrow.startPoint.y, z: arrow.startPoint.z },
      endPoint: { x: arrow.endPoint.x, y: arrow.endPoint.y, z: arrow.endPoint.z },
      scaleCor: this.scaleCor
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Text/index.ts